<template>
  <div class="w-100 my-5">
    <div v-if="transactionList">
      <div class="row mx-auto">
        <div class="col-sm m-2 box-white d-flex flex-column">
          <span class="fa fa-euro-sign font-15">&nbsp;&nbsp;&nbsp;{{ $t('sales_total') }}</span>
          <span class="mt-3 font-bold font-50">{{ getPriceFormat(salesTotalPrice) }}</span>
          <div>
            <span class="font-15 color-black">{{ getPriceFormat(totalPriceRefunded) }}</span>
            <span class="ml-2 font-12 alpha-07">{{ $t('refunded') }}</span>
          </div>
        </div>
        <div class="col-sm m-2 box-white d-flex flex-column">
          <span class="fa fa-euro-sign font-15">&nbsp;&nbsp;&nbsp;{{ $t('total_discount') }}</span>
          <span class="mt-3 font-bold font-50">{{ getPriceFormat(discountPrice) }}</span>
        </div>
        <div class="col-sm m-2 box-white d-flex flex-column">
          <span class="fa fa-euro-sign font-15">&nbsp;&nbsp;&nbsp;{{ $t('tax_price') }}</span>
          <span class="mt-3 font-bold font-50">{{ getPriceFormat(taxPrice) }}</span>
        </div>
        <div class="col-sm m-2 box-white d-flex flex-column">
          <span class="fa fa-euro-sign font-15 color-black">&nbsp;&nbsp;&nbsp;{{ $t('service_charge') }}</span>
          <span class="mt-3 font-bold font-50 color-black">{{ getPriceFormat(serviceCharge) }}</span>
        </div>
        <div class="col-sm m-2 box-white d-flex flex-column">
          <span class="fa fa-euro-sign font-15">&nbsp;&nbsp;&nbsp;{{ $t('sales_volume_organizer') }}</span>
          <span class="mt-3 font-bold font-50">{{ getPriceFormat(netSalePrice) }}</span>
        </div>
      </div>
      <div class="row mx-auto">
        <div class="col-sm m-2 box-white row vertical-center">
          <div class="col-sm my-1 vertical-center" v-if="userInfo">
            <img class="circle-image-30" :src="userInfo.photoUrl ? userInfo.photoUrl : assets.profile" />
            <span class="ml-2 font-15 font-bold">{{ userInfo.userName }}</span>
            <span class="ml-5 font-bold font-15 alpha-07">{{ $t('transaction') }}:</span>
            <span class="mx-5 font-bold font-20">{{ items.length }}</span>
          </div>
          <div class="col-sm my-1 vertical-center" v-else-if="eventInfo">
            <img :width="60" :height="40" :src="eventInfo.photoUrl" />
            <span class="ml-2 font-15 font-bold">{{ eventInfo.name }}</span>
            <span class="ml-5 font-bold font-15 alpha-07">{{ $t('transaction') }}:</span>
            <span class="mx-5 font-bold font-20">{{ items.length }}</span>
          </div>
          <div class="col-sm my-1 vertical-center" v-else>
            <span class="font-bold font-15 alpha-07">{{ $t('transaction') }}:</span>
            <span class="mx-5 font-bold font-20">{{ items.length }}</span>
          </div>
          <div v-if="!isGeneratingPdf" icon small class="cursor-pointer mr-3" @click="exportToPDF" :disabled="items.length === 0">
            <i class="flaticon2-print font-bold font-20 color-black"></i>
          </div>
          <div class="center" v-if="isGeneratingPdf">
            <b-spinner type="grow"></b-spinner>
          </div>
          <DatePicker
            class="col-sm my-1"
            v-model="selectedMonth"
            type="month"
            @change="onMonthChanged"
            :placeholder="$t('select_month')"
          />
          <DatePicker
            class="col-sm my-1"
            v-model="dateRange"
            type="date"
            range
            @change="onDateRangeChanged"
            :placeholder="$t('select_date_range')"
          />
          <div :class="`col-sm my-1 vertical-center ${isMobile ? '' : 'justify-content-end'}`">
            <input class="w-75" v-model="keyword" />
            <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
              <i class="flaticon-circle"></i>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="row mx-auto" v-for="(item, index) in items" :key="(item, index)">
        <div class="col-sm m-2 p-0 box-white row">
          <div class="col-sm-4 d-flex flex-column">
            
            <div class="my-1 vertical-center">
              <img class="circle-image-30" :src="item.organizerPhotoUrl" />
              <span class="ml-2 ellipsis font-12">{{ item.organizerName }}</span>
            </div>
            <span class="my-1 ellipsis font-bold font-12">{{ item.eventName }}</span>
            <div class="mt-2 d-flex justify-content-between" v-for="(detail, index2) in item.details" :key="(detail, index2)">
              <span class="ellipsis font-12">{{ detail.ticketName }}</span>
              <span class="ml-2 font-12">{{ `${getPriceFormat(detail.price)} * ${detail.quantity} = ${getPriceFormat(detail.price * detail.quantity)}` }}</span>
            </div>
          </div>
          <div class="vertical-center">
            <div class="my-5 div-divider-h" v-if="isMobile" />
            <div class="mx-3 div-divider-v" v-else />
          </div>
          <div class="col-sm d-flex flex-column">
            <div class="my-1 vertical-center">
              <img class="circle-image-30" :src="item.buyerPhotoUrl" />
              <span class="ml-2 ellipsis font-12">{{ item.buyerName }}</span>
            </div>
            <div class="mt-5 d-flex justify-content-between">
              <span class="font-12">{{ $t('ticket_price') }}</span>
              <span class="ml-2 font-12">{{ getPriceFormat(item.ticketPrice) }}</span>
            </div>
            <div class="mt-2 d-flex justify-content-between">
              <span class="font-12">{{ $t('tax_price') }}</span>
              <span class="ml-2 font-12">{{ getPriceFormat(item.taxPrice) }}</span>
            </div>
            <div class="mt-2 d-flex justify-content-between">
              <span class="font-12">{{ $t('service_charge') }}</span>
              <span class="ml-2 font-12">{{ getPriceFormat(item.serviceCharge) }}</span>
            </div>
            <div class="mt-2 d-flex justify-content-between" v-if="item.couponDiscount">
              <span class="font-12">{{ $t('discount') }}</span>
              <span class="ml-2 font-12 color-black">-{{ getPriceFormat(item.couponDiscount) }}</span>
            </div>
            <div class="mt-2 d-flex justify-content-between">
              <span class="font-15">{{ $t('total_price') }}</span>
              <span class="ml-2 font-bold font-15">{{ getPriceFormat(item.totalPrice) }}</span>
            </div>
          </div>
          <div class="vertical-center">
            <div class="my-5 div-divider-h" v-if="isMobile" />
            <div class="mx-3 div-divider-v" v-else />
          </div>
          <div class="col-sm d-flex flex-column">
            <div class="my-2 d-flex justify-content-between vertical-center" v-if="item.transactionId.startsWith(PAYMENT_TYPE_PAYPAL_SANDBOX) || item.transactionId.startsWith(PAYMENT_TYPE_STRIPE_TEST)">
              <span class="my-2 font-bold font-15 color-black">Sandbox</span>
              <v-btn icon small @click="deleteTransactionInfoTask(item.transactionId)">
                <i class="flaticon-delete color-black"></i>
              </v-btn>
            </div>
            <span class="mt-2 font-bold font-15 color-black" v-else-if="item.refundRequestedAt">{{ $t('refund') }}</span>
            <span class="mt-2 font-bold font-15" v-else>{{ $t('paid') }}</span>
            <div class="mt-2 d-flex flex-column" v-if="hostname === 'localhost' && item.type">
              <span class="font-12 font-bold color-black">{{ item.type }}</span>
              <span class="ml-auto font-12">{{ item.transactionId }}</span>
            </div>
            <div class="mt-2 d-flex vertical-center">
              <img height="30px" :src="item.transactionId.startsWith(PAYMENT_TYPE_PAYPAL) ? assets.paypal : assets.stripe" />
              <img class="ml-2" height="30px" :src="assets[item.paymentMethod]" v-if="item.paymentMethod && item.paymentMethod !== 'paypal'" />
              <span class="ml-auto font-12">{{ getDateStringFromTimestamp(item.createdAt) }}</span>
            </div>
            <div class="mt-2 d-flex justify-content-between" v-if="item.refundRequestedAt">
              <span class="font-12">{{ $t('requested') }}</span>
              <span class="ml-2 font-bold font-12">{{ getDateStringFromTimestamp(item.refundRequestedAt) }}</span>
            </div>
            <div class="mt-5 d-flex justify-content-between" v-if="item.refundPaidAt">
              <span class="font-12">{{ $t('paid') }}</span>
              <span class="ml-2 font-12 font-bold color-black">{{ getDateStringFromTimestamp(item.refundPaidAt) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="py-40 center" v-if="(items.length === 0)">
        <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t('please_wait') }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1900"
      :pdf-quality="2"
      :manual-pagination="true"
      :html-to-pdf-options="htmlToPdfOptions"
      pdf-format="b5"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      @progress="onProgress"
      ref="transaction_pdf">
      <section slot="pdf-content">
        <div class="template-box" style="padding-left: 60px; padding-right: 60px;">
          <table cellpadding="0" cellspacing="0" style="width: 100%;">
            <tbody>
              <tr>
                <td colspan="3" style="text-align:right; padding-bottom: 30px">
                  {{ getDateStringFromDate(new Date(), "DD.MM.YYYY HH:mm") }}
                </td>
              </tr>
              <tr>
                <td colspan="3" style="text-align:right; padding-bottom: 30px">
                  <img :src="pdfData.logo" style="height:50px; object-fit:contain" />
                </td>
              </tr>
              <tr>
                <!-- <td colspan="4" class="font-bold font-16" style="padding-bottom: 15px">
                  {{ $t('transaction') }} {{ $t('report') }}
                </td> -->
              </tr>
              <tr v-if="pdfData.userName">
                <td colspan="3" style="padding-bottom: 10px">
                  <span class="font-bold font-15">{{ $t('user') }}: </span>{{ pdfData.userName }}
                </td>
              </tr>
              <tr v-if="pdfData.eventName">
                <td colspan="3" style="padding-bottom: 10px">
                  <span class="font-bold font-15">{{ $t('event') }}: </span>{{ pdfData.eventName }}
                </td>
              </tr>
              <tr v-if="pdfData.dateRange">
                <td colspan="3" style="padding-bottom: 20px">
                  <span class="font-bold font-15">{{ $t('date_range') }}: </span>{{ pdfData.dateRange }}
                </td>
              </tr>
              <tr>
                <!-- <td style="border-bottom: 2px solid #535152; width: 20%">
                  <span class="font-bold font-12">{{ $t('transaction') }}</span>
                </td> -->
                <td style="border-bottom: 2px solid #535152; text-align: left" class="font-bold font-12">
                  {{ $t('sales_total') }}
                </td>
                <td style="border-bottom: 2px solid #535152; text-align: center" class="font-bold font-12">
                  {{ $t('total_discount') }}
                </td>
                <td style="border-bottom: 2px solid #535152; text-align: right" class="font-bold font-12">
                  {{ $t('tax_price') }}
                </td>
              </tr>
              <tr>
                <!-- <td style="padding-top: 10px; padding-bottom: 10px">
                  {{ $t('total') }}
                </td> -->
                <td style="text-align: left; padding-top: 10px; padding-bottom: 10px">
                  {{ getPriceFormat(pdfData.netSalePrice) }}
                </td>
                <td style="text-align: center; padding-top: 10px; padding-bottom: 10px">
                  {{ getPriceFormat(pdfData.discountPrice) }}
                </td>
                <td style="text-align: right; padding-top: 10px; padding-bottom: 10px">
                  {{ getPriceFormat(pdfData.taxPrice) }}
                </td>
              </tr>
              <tr>
                <td colspan="2" style="border-top: 2px solid #535152; border-bottom: 2px solid #535152; padding-top: 10px; padding-bottom: 10px" class="font-bold font-15">
                  {{ $t('sales_volume_organizer') }}
                </td>
                <td colspan="1" style="border-top: 2px solid #535152; border-bottom: 2px solid #535152; text-align: right; padding-top: 10px; padding-bottom: 10px" class="font-bold font-15">
                  {{ getPriceFormat(pdfData.netSalePrice) }}
                </td>
              </tr>
              <tr v-if="pdfData.totalPriceRefunded > 0">
                <td style="padding-top: 10px; padding-bottom: 10px; color: #f1416c; font-weight: bold; font-size: 12px">
                  {{ $t('refunded') }}
                </td>
                <td colspan="3" style="text-align: right; padding-top: 10px; padding-bottom: 10px; color: #f1416c; font-weight: bold; font-size: 12px">
                  {{ getPriceFormat(pdfData.totalPriceRefunded) }}
                </td>
              </tr>
              <tr>
                <td colspan="4" style="padding-top: 30px; padding-bottom: 10px" class="font-bold font-14">
                  {{ $t('details') }}:
                </td>
              </tr>
              <tr>
                <td colspan="4" style="border-bottom: 1px solid #ccc; padding-bottom: 10px"></td>
              </tr>
              <template v-for="(event, index) in pdfData.events">
                <tr :key="event.eventId || index">
                  <td colspan="4">
                    <div class="event-block no-break">
                      <div class="event-title font-bold font-12">
                        {{ index + 1 }}. {{ event.eventName }}
                      </div>

                      <div class="event-organizer font-11">
                        {{ $t('organizer') }}: {{ event.organizerName }}
                      </div>

                      <div class="row-line">
                        <div class="left">{{ $t('sales_total') }}</div>
                        <div class="right">{{ getPriceFormat(event.totalAmount - event.serviceCharge) }}</div>
                      </div>

                      <div class="row-line" v-if="event.discountPrice !== 0">
                        <div class="left red">{{ $t('discount') }}</div>
                        <div class="right red">-{{ getPriceFormat(event.discountPrice) }}</div>
                      </div>

                      <div class="row-line" v-if="event.totalPriceRefunded">
                        <div class="left red">{{ $t('refunded') }}</div>
                        <div class="right red">{{ getPriceFormat(event.totalPriceRefunded) }}</div>
                      </div>

                      <div class="divider"></div>

                      <div class="row-line">
                        <div class="left">{{ $t('tax_price') }}</div>
                        <div class="right">{{ getPriceFormat(event.taxAmount) }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <tr>
                <td colspan="4" style="padding-top: 30px"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>


<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueHtml2pdf from 'vue-html2pdf';

import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';
import { getPriceFormat, getDateStringFromTimestamp, getDateStringFromDate, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';
import paypal from '@/assets/image/paypal.png';
import stripe from '@/assets/image/stripe.png';
import card from '@/assets/image/card.png';
import sepa from '@/assets/image/sepa.png';
import sepa_debit from '@/assets/image/sepa.png';
import sofort from '@/assets/image/sofort.png';
import klarna from '@/assets/image/klarna.png';
import giropay from '@/assets/image/giropay.png';

export default {
  name: 'TransactionList',
  components: {
    DatePicker,
    VueHtml2pdf
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    statsMap() {
      return this.$store.state.statsMap;
    },
    userList() {
      return this.$store.state.userList;
    },
    userInfo() {
      if (this.$route.params.userId) {
        return this.userList ? this.userList.find(element => element.userId === this.$route.params.userId) : null;
      } else {
        return null;
      }
    },
    eventList() {
      return this.$store.state.eventList;
    },
    eventInfo() {
      if (this.$route.params.eventId) {
        return this.eventList ? this.eventList.find(element => element.eventId === this.$route.params.eventId) : null;
      } else {
        return null;
      }
    },
    transactionList() {
      return this.$store.state.transactionList;
    },
    params() {
      return this.$route.params;
    }
  },
  watch: {
    params() {
      if (this.keyword) {
        this.keyword = '';
      } else {
        this.refreshData();
      }
    },
    eventList() {
      this.refreshData();
    },
    userList() {
      this.refreshData();
    },
    transactionList() {
      this.refreshData();
    },
    keyword() {
      this.refreshData();
    }
  },
  data() {
    return {
      assets: {
        profile,
        paypal,
        stripe,
        card,
        sepa,
        sepa_debit,
        sofort,
        klarna,
        giropay
      },
      hostname: window.location.hostname,
      selectedMonth: null,
      dateRange: null,
      salesTotalPrice: 0,
      discountPrice: 0,
      taxPrice: 0,
      serviceCharge: 0,
      netSalePrice: 0,
      totalPriceRefunded: 0,
      items: [],
      keyword: '',
      pdfData: {
        logo: require('@/assets/image/pdf_logo.png'),
        userName: '',
        eventName: '',
        dateRange: '',
        salesTotalPrice: 0,
        discountPrice: 0,
        taxPrice: 0,
        serviceCharge: 0,
        netSalePrice: 0,
        totalPriceRefunded: 0,
        events: [],
        transactions: []
      },
      htmlToPdfOptions: {
        filename: 'Tax-report.pdf',
        margin: 10,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      },
      isGeneratingPdf: false
    }
  },
  mounted() {
    this.setDateRange();
    this.refreshData();
  },
  methods: {
    getPriceFormat,
    getDateStringFromTimestamp,
    getDateStringFromDate,
    setDateRange() {
      if (!this.$route.params.userId && !this.$route.params.eventId) {
        const startDate = new Date();
        const endDate = new Date();
        startDate.setDate(startDate.getDate() - 7);
        this.dateRange = [startDate, endDate];
      }
    },
    onMonthChanged(value, type) {
      if (value) {
        this.dateRange = [null, null];
      } else {
        this.setDateRange();
      }
      this.refreshData();
    },
    onDateRangeChanged(value, type) {
      if (value && value.length === 2 && value[0] && value[1]) {
        this.selectedMonth = null;
      } else {
        this.selectedMonth = new Date();
      }
      this.refreshData();
    },
    refreshData() {
      if (this.transactionList && this.userList && this.eventList) {
        var totalPrice = 0;
        var taxPrice = 0;
        var serviceCharge = 0;
        var netSalePrice = 0;
        var totalPriceRefunded = 0;
        var discountPrice = 0;
        const items = [];
        const keyword = this.keyword.toLowerCase();
        this.transactionList.filter(element => this.filterTransaction(element)).forEach(transactionInfo => {
          const buyerInfo = this.getUserInfo(transactionInfo.buyerId);
          const organizerInfo = this.getUserInfo(transactionInfo.organizerId);
          const eventInfo = this.getEventInfo(transactionInfo.eventId);
          if (buyerInfo && organizerInfo && eventInfo &&
            (eventInfo.name.toLowerCase().includes(keyword) || buyerInfo.userName.toLowerCase().includes(keyword) || organizerInfo.userName.toLowerCase().includes(keyword))) {
            const item = JSON.parse(JSON.stringify(transactionInfo));
            item['buyerName'] = buyerInfo.userType === 3 ? `Direct buy - ${buyerInfo.email}` : buyerInfo.userName;
            item['buyerPhotoUrl'] = buyerInfo.photoUrl ? buyerInfo.photoUrl : this.assets.profile;
            item['organizerName'] = organizerInfo.userName;
            item['organizerPhotoUrl'] = organizerInfo.photoUrl ? organizerInfo.photoUrl : this.assets.profile;
            item['eventName'] = eventInfo.name;
            item['eventPhotoUrl'] = eventInfo.photoUrl;
            discountPrice += transactionInfo.couponDiscount || 0;
            totalPrice += transactionInfo.totalPrice;
            taxPrice += transactionInfo.taxPrice;
            serviceCharge += transactionInfo.serviceCharge;
            netSalePrice += transactionInfo.ticketPrice - (transactionInfo.couponDiscount || 0);
            if (transactionInfo.refundPaidAt) {
              totalPriceRefunded += transactionInfo.totalPrice;
            }
            items.push(item);
          }
        });
        items.sort((a, b) => (a.createdAt.seconds < b.createdAt.seconds) ? 1 : -1);
        this.items = items;
        this.salesTotalPrice = totalPrice;
        this.taxPrice = taxPrice;
        this.serviceCharge = serviceCharge;
        this.discountPrice = discountPrice;
        this.netSalePrice = netSalePrice;
        this.totalPriceRefunded = totalPriceRefunded;
      }
    },
    filterTransaction(element) {
      /*if (window.location.hostname !== 'localhost' && element.transactionId.startsWith(this.PAYMENT_TYPE_STRIPE_TEST)) {
        return false;
      }*/
      if (this.selectedMonth && getDateStringFromDate(this.selectedMonth, 'YYYY-MM') !== getDateStringFromTimestamp(element.createdAt, 'YYYY-MM')) {
        return false;
      }
      if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]) {
        const createdTime = element.createdAt.toDate().getTime();
        if (createdTime < this.dateRange[0].getTime() || createdTime > this.dateRange[1].getTime()) {
          return false;
        }
      }
      if (this.$route.params.userId) {
        return element.buyerId === this.$route.params.userId || element.organizerId === this.$route.params.userId;
      } else if (this.$route.params.eventId) {
        return element.eventId === this.$route.params.eventId;
      } else {
        return true;
      }
    },
    getUserInfo(userId) {
      return this.userList ? this.userList.find(element => element.userId === userId) : null;
    },
    getEventInfo(eventId) {
      return this.eventList ? this.eventList.find(element => element.eventId === eventId) : null;
    },
    deleteTransactionInfoTask(transactionId) {
      const params = {
        functionName: 'deleteTransactionInfo',
        transactionId: transactionId
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    exportToPDF() {
      if (this.items.length === 0) {
        this.$toast.info(this.$t('no_data_found') || 'No data found');
        return;
      }

      this.isGeneratingPdf = true;
      // Build date range string
      let dateRangeStr = '';
      if (this.selectedMonth) {
        dateRangeStr = getDateStringFromDate(this.selectedMonth, 'MMMM YYYY');
      } else if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]) {
        dateRangeStr = `${getDateStringFromDate(this.dateRange[0], 'DD.MM.YYYY')} - ${getDateStringFromDate(this.dateRange[1], 'DD.MM.YYYY')}`;
      } else {
        dateRangeStr = this.$t('all') || 'All';
      }

      // Prepare event summary data for PDF (group by event)
      const eventSummaryMap = {};
      this.items.forEach(item => {
        const eventId = item.eventId;
        if (!eventSummaryMap[eventId]) {
          eventSummaryMap[eventId] = {
            eventId: eventId,
            eventName: item.eventName,
            organizerName: item.organizerName,
            totalAmount: 0,
            taxAmount: 0,
            discountPrice: 0,
            totalPriceRefunded: 0,
            serviceCharge: 0
          };
        }
        eventSummaryMap[eventId].totalAmount += item.totalPrice || 0;
        eventSummaryMap[eventId].taxAmount += item.taxPrice || 0;
        eventSummaryMap[eventId].discountPrice += item.couponDiscount || 0;
        if (item.refundRequestedAt)
          eventSummaryMap[eventId].totalPriceRefunded += item.totalPrice || 0;
        eventSummaryMap[eventId].serviceCharge += item.serviceCharge || 0;
      });
      const events = Object.values(eventSummaryMap);

      // Populate pdfData
      this.pdfData = {
        logo: require('@/assets/image/pdf_logo.png'),
        userName: this.userInfo ? this.userInfo.userName : '',
        eventName: this.eventInfo ? this.eventInfo.name : '',
        dateRange: dateRangeStr,
        salesTotalPrice: this.salesTotalPrice,
        discountPrice: this.discountPrice,
        taxPrice: this.taxPrice,
        serviceCharge: this.serviceCharge,
        netSalePrice: this.netSalePrice,
        totalPriceRefunded: this.totalPriceRefunded,
        events: events,
        transactions: []
      };

      // Set filename
      let filename = 'Tax-report';
      if (this.userInfo) {
        filename += `-${this.userInfo.userName}`;
      } else if (this.eventInfo) {
        filename += `-${this.eventInfo.name}`;
      }
      this.htmlToPdfOptions.filename = `${filename}.pdf`;

      // Generate PDF
      this.$nextTick(() => {
          this.$refs.transaction_pdf.generatePdf();
      });
    },
    onProgress(progress) {
      if (progress === 0) {
        // PDF generation started
      } else if (progress === 100) {
        // PDF generation completed
        this.isGeneratingPdf = false;
        this.$toast.success(this.$t('pdf_generated_successfully') || 'PDF generated successfully');
      }
    }
  }
};
</script>